<template>
	<div class="article">
		<Bannerinner/>
	   <div class="content">
		   <div class="titleinfo">
			<h2 class="mianbao">
				  <router-link to="/">首页 > </router-link>
				  <router-link :to="{path:pathInfo.path}">{{pathInfo.name}} > </router-link>
			</h2>
		   </div>
		   <div class="contbox">
			   <h3 class="conttitle" >{{arcTitle}}</h3>
			   <div class="continfo">
				   <p>来源：<a href="/">北京冠领律师事务所</a> </p>
				   <p>时间：{{arcTime}}</p>
				   <!-- <p>阅读：14</p> -->
			   </div>
			   
			   <div v-if="video" class="contwrap"> <video :src="video" controls></video></div>
			   <div v-else class="contwrap" v-html="arcContent" ></div>
			   
			   <div class="tagbox" v-show="type != 'zm'">
					<strong>标签：</strong>
					<a href="javascript:void(0)" @click="search(item)" v-for="item,index in targ" >{{item}}</a>
			   </div>
				<div class="shangxia" v-show="type != 'zm'">
						<a href="javascript:void(0)" v-if="up == null" >上一篇：没有了</a>
						<router-link :to="{path:up.id+'.html'}" v-else :title="up.title">上一篇：{{up.title}}</router-link>

						<a href="javascript:void(0)" v-if="down == null" >下一篇：没有了</a>
						<router-link :to="{path:down.id+'.html'}" v-else :title="down.title">下一篇：{{down.title}}</router-link>
				</div> 
			   <div class="xiangguan">
				   <h3><strong>相关案例</strong><router-link :to="{path:'/anli/index.html'}">查看更多</router-link></a></h3>
				   <ul>
					   <li v-for="item,index in anliData" :key="item.id">
						   <router-link :to="{path:'/anli/v/'+ item.id +'.html'}">
							   <div class="xgimg"><img :src="item.thumb" alt=""></div>
							   <div class="xginfo">
								   <strong>{{item.title}}</strong>
								   <em>{{item.create_time}}</em>
							   </div>
						   </router-link>
						  
					   </a></li>
				   </ul>
			   </div>
		   </div>
   
	   </div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import Bannerinner from "@/components/Bannerinner"
	import { title } from '../global/common.js'
	export default{
		name: 'Article',
		components:{
			Bannerinner
		},
		data(){
			return {
				breadcrumbList:[],
				arcTitle:'',
				arcTime:'',
				arcContent:'',
				catid:0,
				upArc:[],
				downArc:[],
				preshow: false,
				nextshow: false,
				xgal:[],
				lmname:'',
				currentUrl:'',
				prenextarc:'',
				istv:true,
				tvname:'cctv',
				abouthide:true,
				rmbq:'',
				from:'',
				arcid:0,
				url:'',
				NextOrPre:'',
				down:'',
				up:'',
				video:'',
				pathInfo:[],
				anliData:[],
				type:''
			}
		},
		methods:{
			getArc(){
				let that = this
				request({
					url: that.url+that.arcid,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let data = jsondata['data']
							if(that.type == 'zm'){
								that.arcTitle = data.title
								data.rmbq = data.rmbq == undefined ? 0 : data.rmbq
								that.rmbq = data.rmbq
								that.arcTime = data.create_time.split(' ')[0]
								// that.arcContent = data.body.replace(/\s(src=")/g, " $1http://api.guanlingls.com")
								if(data.body.length > 20){
									that.arcContent = data.body
								}else{
									that.arcContent = data.body.replace(/\s(src=")/g, " $1http://api.guanlingls.com")
								}
								
								// that.getlmName(data.catid)
								that.getAnLi()
								
							}else{
								
								if(data.video_url){
									that.video = data.video_url
								}
								that.arcTitle = data.title
								// console.log(data.rmbq)
								data.rmbq = data.rmbq == undefined ? 0 : data.rmbq
								that.rmbq = data.rmbq
								that.arcTime = data.create_time.split(' ')[0]
								that.arcContent = data.content.replace(/\s(src=")/g, " $1http://api.guanlingls.com")
								that.getNextOrPre(data.id,data.catid)
								that.getlmName(data.catid)
								that.getAnLi()
							}

							
							
						}
					}]
				})
			},
			getNextOrPre(id,lmid){
				let that = this
				request({
					url: that.NextOrPre + 'id='+id+'&catid='+lmid,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let data = jsondata['data']
							// console.log(data)
							that.down = data['down']
							that.up = data['up']
						}
					}]
				})
			},
			getAnLi(){
				let that = this
				request({
					url: '/anli/read?catid=7&id=1&page=1&page_size=3',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									value['create_time'] = value['create_time'].split(' ')[0]
									that.anliData.push(value)
								}
							})
		
						}
					}]
				})
			},
			getlmName(catid){
				let that = this
				request({
					url: '/Category/read?id='+catid,
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.lmname = jsondata['data']['name']
							document.title = jsondata['data']['name'] + '-' + title
						}
					}]
				})
			},
			search(name){
				this.$router.push({ path:'/search/index.html',query:{'name':encodeURI(name)}})
			},
			initData(){
				let id = this.$route.params.id;
				let name = this.$route.name;
				this.arcid = id
				this.pathInfo = this.$route.meta.parent[0]
				let biaoshi = this.$route.params.biaoshi
				
				if(biaoshi == 'v'){
					this.type = ''
				}else if(biaoshi == 'm'){
					this.type = 'zm'
				}
				
				if(name == 'honorhtml'){
					this.from = 'honor'
					this.url = '/honor/'+this.type+'honorlist?id='
					this.NextOrPre = '/honor/honornext?'
				}else if(name == 'mediahtml'){
					this.from = 'news'
					this.url = '/news/'+this.type+'newslist?id='
					this.NextOrPre = '/news/newsnext?'
				}else if(name == 'cctvhtml'){
					this.from = 'video'
					this.url = '/video/'+this.type+'videolist?id='
					this.NextOrPre = '/video/videonext?'
				}else if(name == 'noticlehtml'){
					this.from = 'gonggao'
					this.url = '/gonggao/'+this.type+'gonggaolist?id='
					this.NextOrPre = '/gonggao/gonggaonext?'
				}else if(name == 'anlihtml'){
					this.from = 'anli'
					this.url = '/anli/'+this.type+'anlilist?id='
					this.NextOrPre = '/anli/anlinext?'
				}else if(name == 'teamhtml'){
					this.from = 'team'
					this.url = '/team/'+this.type+'teamlist?id='
					this.NextOrPre = '/team/teamnext?'
				}
				
				this.getArc()
			}
		},
		computed:{
			targ(){
				let rmbq = this.rmbq
				// console.log(rmbq)
				if(rmbq == 0){
					return rmbq
				}else{
					let rmbqArr = rmbq.split(',')
					return rmbqArr
				}
			}
		},
		created() {
			this.initData()
		},
		watch:{
		  $route(to, from){
			this.initData()
		  }
		}
	}
</script>

<style lang="scss">
.article{
	.content{
	    background-color: #fff;
	    .contbox{
	        margin-top: .3rem;
	        padding-bottom: .2rem;
	        
	        .conttitle{
	            font-size: .32rem;
	            text-align: center;
	            color: #323232;
	            font-weight: 900;
	            margin-bottom: .2rem;
	            line-height: .5rem;
	            padding: 0 .2rem;
	        }
	        .continfo{
	            display: flex;
	            justify-content: center;
	            border-bottom: 1px solid #e6e6e6;
	            padding-bottom: .2rem;
	            margin-bottom: .2rem;
	            p{
	                font-size: .26rem;
	                color: #919191;
	                margin: 0 .1rem;
	                a{
	                    color: #919191; 
	                }
	            }
	        }
	        .contwrap{
	            padding: .5rem .3rem 0;
				video{
					width: 100%;
				}
	            p{
	                font-size: .28rem;
	                line-height: .47rem;
	                padding: .2rem 0;
	                // text-indent: 2em;
	                color: #646464;
	            }
	            img{
	                width: 70% !important;
					height: auto !important;
	                margin: 0 auto;
	            }
	        }
	        .tagbox{
	            padding: .2rem .3rem .3rem;
	            font-size: .28rem;
	            a{
	                font-size: .28rem;
	                margin-right: .1rem;
	            }
	        }
	        .shangxia{
	            padding: 0 .3rem;
	            a{
	                display: block;
	                padding: .1rem 0;
	                font-size: .28rem;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
	            }
	        }
	        .xiangguan{
	            padding: 0 .3rem;
	            margin-top: .4rem;
	            h3{
	                display: flex;
	                justify-content: space-between;
	                border-bottom: 1px solid #eee;
	                padding-bottom: .1rem;
	                strong{
	                    font-size: .32rem;
	                    color: #d71617;
	                    font-weight: bold;
	                }
	                a{
	                    font-size: .28rem;
	                }
	            }
	            ul{
	                li{
	                    padding: .25rem 0;
	                    border-bottom: 1px solid #eee;
	                    a{
	                        display: flex;
	                        justify-content: space-between;
	                        .xgimg{
	                            width: 2.2rem;
								height: 1.65rem;
								overflow: hidden;
	                            margin-right: .1rem;
								
	                        }
	                        .xginfo{
	                            width: 4.5rem;
	                            display: flex;
	                            flex-wrap: wrap;
	                            flex-direction: column;
	                            justify-content: center;
	                            strong{
	                                font-size: .28rem;
	                            }
	                            em{
	                                display: flex;
	                                align-items: center;
	                                margin-top: .1rem;
	                                font-size: .26rem;
	                                color: #999;
	                                text-indent: .4rem;
	                                background: url('../assets/images/img_58.png') no-repeat left center/.3rem;
	                                height: .3rem;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }
	}

}
	
</style>